module.exports = __webpack_public_path__ + "img/DJI_0086.be93efd3.jpg";